import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { isNil } from 'ramda';
import React, { memo } from 'react';

export interface SizeProps {
    size?: number;
    maxDigitsCount: number;
}

export const Size = memo(({ size, maxDigitsCount }: SizeProps) => <div>{!isNil(size) && bytesToNDigits(size, maxDigitsCount).value}</div>);

Size.displayName = 'Size';
